export function parseBooleanDef() {
    return {
        type: 'boolean',
    };
}
//# sourceMappingURL=boolean.mjs.map